import { RG_TYPE } from "@project-rouge/rg-core";
function getActionGia(unit, corridorWidth, isDoubleLoaded) {
  const effectiveCorrWidth = isDoubleLoaded ? corridorWidth : 0.5 * corridorWidth;
  let gia = unit.size[0] * effectiveCorrWidth;
  if (unit.type === RG_TYPE.Apartment) {
    gia += unit.children.reduce((sum, m) => sum + m.size[0] * m.size[1], 0);
    if (unit.data.closeLength)
      gia -= unit.data.closeLength * effectiveCorrWidth;
  }
  if (unit.type === RG_TYPE.Apartment) {
    gia += unit.size[0] * unit.size[1];
  }
  return gia;
}
export {
  getActionGia
};
//# sourceMappingURL=index251.js.map
